export default {
  "home.heading.default": "ab in den call",
  "home.heading.loading": "öffne room...",
  "home.heading.join": "ready?",
  "home.heading.joined": "du bist drin",
  "home.heading.pending": "warten auf den host",
  "home.body.default": "room erstellen, link droppen, viben.",
  "home.body.loading": "sekunde, lade den room.",
  "home.body.join": "check cam und mic, dann komm rein.",
  "home.body.joined": "room ist live. teil den link oder leg los.",
  "home.body.joined_in_room": "im room — komm dazu oder teil den link.",
  "home.body.pending": "room ist locked. der host lässt dich gleich rein.",
  "home.cta.create": "Room erstellen",
  "home.cta.join": "Room beitreten",
  "home.cta.enter": "Room betreten",
  "home.cta.creating": "Erstelle...",
  "home.cta.joining": "Joine...",
  "home.cta.opening": "Öffne...",
  "home.cta.pending": "Warte auf Host...",
  "home.copy_link": "link kopieren",
  "home.copied": "kopiert!",
  "home.leave": "room verlassen",
  "home.back": "zurück",
  "home.no_participants": "noch niemand hier",
  "home.join_by_code": "mit code joinen",
  "home.code_placeholder": "code eingeben",
  "home.name_placeholder": "dein name",
  "home.people_one": "person",
  "home.people_other": "leute",
  "home.marketing.invite.title": "Room erstellen,\nLink teilen.",
  "home.marketing.invite.body": "Ein Tap und los geht's. Teil den Link mit Freunden und alle können joinen — ohne Download, ohne Anmeldung.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Dein Look,\ndeine Wahl.",
  "home.marketing.look.body": "Color Grading, Softening, Vignette — oder blur dein Gesicht komplett. Deine Cam, dein Look.",
  "home.marketing.host.title": "Dein Space,\ndeine Regeln.",
  "home.marketing.host.body": "Room locken, Leute muten oder ganz kicken. Der Host hat die Kontrolle.",
  "home.marketing.host.locked": "Room locked",
  "home.marketing.host.waiting_to_join": "Warten aufs Joinen",
  "home.marketing.host.wants_to_join": "will rein",
  "home.marketing.anything.title": "Eigentlich für alles.",
  "home.marketing.anything.body": "Study Sessions, Game Nights, Standups, zusammen was schauen — oder einfach nur abhängen.",
  "home.marketing.use_case.study_group": "📚 lerngruppe",
  "home.marketing.use_case.game_night": "🎮 game night",
  "home.marketing.use_case.standup": "💼 standup",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ catch up",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 buchclub",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "call beendet",
  "ended.left": "du hast den room verlassen.",
  "ended.room_ended": "{title} ist für dich beendet.",
  "ended.rejoin": "wieder rein",
  "ended.rejoining": "joine wieder...",
  "ended.home": "zurück zur startseite",
  "call.connecting": "verbinde",
  "call.waiting": "warte auf andere",
  "call.invite_code": "invite code",
  "call.audio_on": "ton an",
  "call.muted": "gemutet",
  "call.listening": "Hört zu",
  "call.audio_muted": "Ton gemutet",
  "call.speaking": "spricht",
  "call.you": "du",
  "call.you_label": "Du",
  "call.you_suffix": "(du)",
  "call.chat_placeholder": "schreib was...",
  "call.guest": "gast",
  "call.room_fallback": "room",
  "call.focus_view": "Fokus-Ansicht",
  "call.grid_view": "Grid-Ansicht",
  "call.swap_main_video": "Hauptvideo tauschen",
  "call.open_chat": "Chat öffnen",
  "call.close_chat": "Chat schließen",
  "call.leave_room": "Room verlassen",
  "call.confirm_leave": "Verlassen?",
  "call.mic_on": "Mic an",
  "call.muted_label": "Gemutet",
  "call.camera_off": "Cam aus",
  "call.connect_failed": "Verbindung fehlgeschlagen — check dein Internet und versuch's nochmal.",
  "call.camera_access_failed": "Kein Zugriff auf deine Cam. Check die Browser-Rechte und versuch's nochmal.",
  "call.recording_failed": "Aufnahme konnte nicht starten. Der Call läuft ohne weiter.",
  "call.initialize_failed": "Irgendwas lief schief. Bitte lad die Seite neu.",
  "call.participants": "Leute",
  "call.open_participants": "Leute anzeigen",
  "call.close_participants": "Leute ausblenden",
  "call.lock_room": "Room locken",
  "call.unlock_room": "Room öffnen",
  "call.locked": "locked",
  "call.unlocked": "offen",
  "call.kick_member": "Aus dem Room kicken",
  "call.mute_member": "Muten",
  "call.unmute_member": "Entmuten",
  "call.muted_by_host": "Vom Host gemutet",
  "call.waiting_to_join": "Warten aufs Joinen",
  "call.approve": "Reinlassen",
  "call.deny": "Ablehnen",
  "call.profile_actions": "Profil-Aktionen",
  "call.profile_in_room": "Im Room",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Du",
  "call.profile_action_mute": "Ton muten",
  "call.profile_action_mute_meta": "Nur für dich — die Person merkt nichts",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "Starte einen privaten Chat",
  "call.profile_action_view": "Ganzes Profil ansehen",
  "call.profile_action_view_meta": "Bio, Sprachen, letzte Sessions",
  "call.profile_action_report": "Melden",
  "call.profile_action_report_meta": "Fürs Moderations-Team markieren",
  "call.profile_sheet_close": "Profil-Aktionen schließen",
  "call.profile_open_actions": "Profil-Aktionen öffnen",
  "call.dm_title": "Direct Message",
  "call.dm_back": "Zurück zu Aktionen",
  "call.dm_close": "DM schließen",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "In diesem Room",
  "call.dm_private_label": "Privater Chat",
  "call.dm_private_meta": "Nur ihr beide seht diese Nachrichten",
  "call.dm_input_placeholder": "Schreib eine private Nachricht…",
  "call.dm_send": "Senden",
  "call.dm_just_now": "gerade eben",
  "call.dm_seen_just_now": "Gerade gelesen",
  "call.dm_typing": "{name} tippt…",
  "call.dm_minimize": "Minimieren",
  "call.dm_active_indicator": "Chat öffnen",
  "call.dm_unread_messages": "{count} ungelesen",
  "call.dm_toast_tap_to_open": "Tippen zum Öffnen",
  "call.dm_reopen_aria": "Chat mit {name} wieder öffnen",
  "home.join_denied": "Der Host hat dich nicht reingelassen.",
  "home.error.room_not_found": "Diesen Room-Code gibt's nicht.",
  "home.error.profile_required": "Richte dein Profil ein, um weiterzumachen.",
  "home.cta.set_up_profile": "Profil einrichten",
  "home.profile_trigger_new": "Tippen, um Infos hinzuzufügen",
  "home.profile_trigger_new_aria": "Profil einrichten",
  "home.profile_trigger_edit_aria": "Profil bearbeiten",
  "profile.eyebrow_new": "sag hi",
  "profile.eyebrow_edit": "dein profil",
  "profile.title_new": "Mach's zu deinem.",
  "profile.title_edit": "Profil bearbeiten",
  "profile.subtitle": "Ein paar kurze Infos, damit andere wissen, mit wem sie im Call sind.",
  "profile.add_photo": "Foto hinzufügen",
  "profile.add_photo_soon": "fotos kommen bald",
  "profile.photo_empty": "tippen für ein foto",
  "profile.photo_ready": "foto ready",
  "profile.photo_save_first": "speicher dein profil, bevor du ein foto hochlädst",
  "profile.photo_crop_caption": "foto zuschneiden",
  "profile.photo_auto_caption": "ziehen und zoomen, wird automatisch gespeichert",
  "profile.photo_upload": "Foto hochladen",
  "profile.photo_replace": "Foto austauschen",
  "profile.photo_remove": "Foto löschen",
  "profile.photo_cancel": "Abbrechen",
  "profile.photo_save": "Foto speichern",
  "profile.photo_uploading": "Lade Foto hoch…",
  "profile.photo_removing": "Lösche Foto…",
  "profile.photo_choose_another": "Anderes auswählen",
  "profile.photo_drag_hint": "Zieh das Foto in den Kreis. Änderungen werden automatisch gespeichert.",
  "profile.photo_zoom": "Zoom",
  "profile.photo_horizontal": "Horizontal zuschneiden",
  "profile.photo_vertical": "Vertikal zuschneiden",
  "profile.name_label": "Name",
  "profile.name_placeholder": "Wie sollen wir dich nennen?",
  "profile.gender_label": "Ich bin",
  "profile.gender.woman": "Frau",
  "profile.gender.man": "Mann",
  "profile.gender.unspecified": "Sag ich lieber nicht",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "optional",
  "profile.bio_placeholder": "Sprachen, Hobbys, was auch immer…",
  "profile.cta_new": "Let's go",
  "profile.cta_edit": "Änderungen speichern",
  "profile.saving": "Speichere…",
  "profile.close": "Schließen",
  "profile.error.save_failed": "Profil konnte nicht gespeichert werden. Versuch's nochmal.",
  "profile.error.avatar_invalid_type": "Wähl ein PNG, JPEG, GIF oder WebP.",
  "profile.error.avatar_too_large": "Das Bild muss kleiner als 5 MB sein.",
  "profile.error.avatar_too_small": "Das Bild muss mindestens 96x96 Pixel groß sein.",
  "profile.error.avatar_load_failed": "Bild konnte nicht gelesen werden. Versuch ein anderes.",
  "profile.error.avatar_failed": "Foto-Upload fehlgeschlagen. Versuch's nochmal.",
  "profile.error.avatar_remove_failed": "Foto konnte nicht gelöscht werden. Versuch's nochmal.",
  "effects.title": "Effekte",
  "effects.soft": "Soft Focus",
  "effects.vignette": "Vignette",
  "effects.face": "Face Blur",
  "effects.face_preview_only": "Face Blur (nur Preview)",
  "effects.face_viewer_side": "Face Blur (für andere)",
  "effects.face_strength": "Face Blur Stärke",
  "effects.grade.off": "AUS",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "WARM",
  "effects.grade.cool": "COOL",
  "effects.grade.bw": "S/W",
  "camera.off": "cam ist aus",
  "camera.check": "check deine cam",
  "camera.retry": "cam nochmal probieren",
  "camera.ready": "cam ready",
  "camera.idle.title": "Mach deine Cam an",
  "camera.idle.hint": "Wir fragen deinen Browser nach Rechten, wenn du ready bist.",
  "camera.idle.button": "Cam anmachen",
  "camera.status.idle": "Warten auf dich",
  "camera.status.off": "Cam ist aus",
  "camera.status.loading": "Frage Cam-Rechte an...",
  "camera.status.denied": "Erlaub den Cam-Zugriff im Browser und versuch's nochmal.",
  "camera.status.error": "Cam-Preview fehlgeschlagen. Versuch's nochmal.",
  "camera.status.unsupported": "Dieser Browser unterstützt keinen Cam-Zugriff.",
  "camera.status.insecure": "Cam-Zugriff braucht HTTPS oder localhost.",
  "camera.guest_name_placeholder": "Gast-Name",
  "camera.flip": "Cam wechseln",
  "camera.save_name": "Speichern",
  "camera.edit_name": "Name bearbeiten",
  "mic.on": "Mic ausmachen",
  "mic.off": "Mic anmachen",
  "video.on": "Cam ausmachen",
  "video.off": "Cam anmachen",
  "chat.title": "chat",
  "chat.close": "Chat schließen",
  "chat.loading": "lädt...",
  "chat.load_earlier": "ältere laden",
  "chat.empty": "noch keine nachrichten",
  "chat.send_error": "Nachricht ging nicht raus — versuch's nochmal.",
  "chat.input_placeholder": "schreib was...",
  "room.host": "Host",
  "app.room_default_title": "Room erstellen",
  "app.chat_connection_rejected": "Chat-Verbindung fehlgeschlagen — lad die Seite neu.",
  "app.copy_failed": "Link konnte nicht kopiert werden. Versuch's manuell.",
  "app.chat_not_connected": "Chat ist noch nicht verbunden. Gib ihm 'ne Sekunde und versuch's nochmal.",
  "footer.terms": "AGB",
  "footer.copyright": "© 2026 Yano.AI"
}
